<template>
    <section class="product">
        <img
            src="@/assets/images/product__title.png"
            class="product__title"
            alt="2%水楊酸精華團滅粉刺痘痘"
            loading="lazy"
            data-aos="fade-up"
            data-aos-duration="1500"
        />
        <img
            src="@/assets/images/product__subtitle.png"
            class="product__subtitle"
            alt="華麗復仇！擺脫黑歷史"
            loading="lazy"
            data-aos="fade-up"
            data-aos-duration="1500"
        />

        <div class="product__detail" :class="{ showMe: showMe }" ref="productDetail">
            <div class="product__detail__content">
                <Transition>
                    <div v-if="!showMe">
                        <span>
                            全球刷酸始祖<br />
                            去角質前導精華
                        </span>
                        <img
                            v-if="!showMe"
                            src="@/assets/images/arrow_d.svg"
                            alt="showMe"
                            loading="lazy"
                        />
                    </div>
                    <div v-else>
                        <span>
                            全球每7秒銷售1瓶！<br />
                            最高濃度2%水楊酸<br />
                            代謝角質、4周角質-23%<br />
                            通暢毛孔、預防粉刺痘痘
                        </span>
                    </div>
                </Transition>
            </div>
            <div class="product__detail__content">
                <Transition>
                    <div v-if="!showMe">
                        <span>
                            全膚質適用<br />
                            通過敏感性測試
                        </span>
                        <img v-if="!showMe" src="@/assets/images/arrow_d.svg" alt="showMe" loading="lazy" />
                    </div>
                    <div v-else>
                        <span>
                            通過敏感性測試！<br />
                            添加綠茶與丁二醇<br />
                            舒緩痘痘不適<br />
                            穩膚保濕、強化吸收
                        </span>
                    </div>
                </Transition>
            </div>
        </div>
        <img
            src="@/assets/images/product__img.png"
            class="rwdimg"
            alt="2%水楊酸精華"
            loading="lazy"
            data-aos="fade-up"
            data-aos-duration="1500"
        />
        <img
            src="@/assets/images/product__title2.png"
            class="product__title2"
            alt="皮膚科醫師認證最高濃度水楊酸"
            loading="lazy"
            data-aos="fade-up"
            data-aos-duration="1500"
        />
        <img
            src="@/assets/images/product__subtitle2.png"
            class="product__subtitle"
            alt="科研實證！最強淨膚實力"
            loading="lazy"
            data-aos="fade-up"
            data-aos-duration="1500"
        />
        <div class="product__desciption" data-aos="fade-up">
            <div class="product__desciption__content">
                <img
                    src="@/assets/images/product__paula.png"
                    class="paula"
                    alt="2%水楊酸精華"
                    loading="lazy"
                    data-aos="fade-zoom-in"
                    data-aos-duration="1500"
                />
                <img
                    src="@/assets/images/product__bubble1.png"
                    class="product__bubble one"
                    alt="90%改善粉刺"
                    loading="lazy"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                    data-aos-delay="300"
                />
                <img
                    src="@/assets/images/product__bubble2.png"
                    class="product__bubble two" alt="90%暢通毛孔" data-aos="zoom-in"
                    data-aos-duration="1500" data-aos-delay="400" />
                <img
                    src="@/assets/images/product__bubble3.png"
                    class="product__bubble three"
                    alt="96%明亮均勻"
                    loading="lazy"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                    data-aos-delay="500"
                />
                <img
                    src="@/assets/images/product__bubble4.png"
                    class="product__bubble four"
                    alt="89%細緻光滑"
                    loading="lazy"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                    data-aos-delay="700"
                />
                <img
                    src="@/assets/images/product__bubble5.png"
                    class="product__bubble five"
                    alt="23%角質改善"
                    loading="lazy"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                    data-aos-delay="600"
                />
            </div>
        </div>
        <p data-aos="fade-up" data-aos-duration="1500">根據29位受試者持續使用四周的自我評估結果</p>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const productDetail = ref(null);
const showMe = ref(false);

const options = {
    rootMargin: "0% 0% -20% 0%",
    threshold: 1,
};

const callback = (entries) => {
    showMe.value = entries[0].isIntersecting;
}

const observer = new IntersectionObserver(callback, options);


onMounted(() => {
    observer.observe(productDetail.value);
})

</script>

<style lang="scss" scoped>
@import '@/styles/theProduct';
</style>
